module.exports = __webpack_public_path__ + "media/images/responsive/page_common/recommend/recommend_wayo-edcd4822682dcc21a135df6f9994e80c.jpg";